import { createContext } from 'preact-context';
import { LocationType } from './LocationType';

const { Consumer, Provider } = createContext<LocationType>(null);

export { Consumer, Provider };
